export const PublicDic = {
    'lingotalk': {
        'fa': 'لینگوتاک'
    },
    'login': {
        'fa': 'ورود'
    },
    'signup': {
        'fa': 'ثبت نام'
    },
    'logout': {
        'fa': 'خروج'
    },
    'confirm': {
        'fa': 'تایید'
    },
    'cancel': {
        'fa': 'لغو'
    },
    'price': {
        'fa': 'قیمت'
    },
    'free': {
        'fa': 'رایگان'
    },
    'from': {
        'fa': 'از'
    },
    'to': {
        'fa': 'تا'
    },
    'session': {
        'fa': 'جلسه'
    },
    'package': {
        'fa': 'پکیج'
    },
    'minute': {
        'fa': 'دقیقه'
    },
    'terms': {
        'fa': 'قوانین و مقررات'
    },
    'payment': {
        'fa': 'پرداخت'
    },
    'Toman': 'تومان',
    'TousandToman': 'هزار تومان',
}